// TYPES
const MAIN_SET_COUNTER = 'MAIN_SET_COUNTER'
const SET_LAYOUT = 'SET_LAYOUT'


const state = () => ({
    layout: 'simple-layout',
})

const actions = {
    set_layout({ commit }, payload) {

        commit('SET_LAYOUT', payload)
    }
}

const mutations = {
    [MAIN_SET_COUNTER](state, obj) {
        state.counter = obj.counter
    },
    SET_LAYOUT(state, payload) {
        state.layout = payload
    },

}

const getters = {

    CURRENT_LAYOUT: state => {
        return state.layout
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}